import { render, staticRenderFns } from "./modalAddAddress.vue?vue&type=template&id=234db694&"
import script from "./modalAddAddress.vue?vue&type=script&lang=js&"
export * from "./modalAddAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports